<template>
  <div>
    <b-alert v-if="objeto.item.CargoEstablecimiento.CargoDetalleCurricular.length === 0" variant="danger" show>
      No existen detalles
    </b-alert>
    <b-card v-if="objeto.item.CargoEstablecimiento.CargoDetalleCurricular.length > 0">
      <b-row class="mb-2">
        <b-list-group>
          <b-list-group-item v-for="item in objeto.item.CargoEstablecimiento.CargoDetalleCurricular" v-bind:key="item.Id">
            <b>{{ "Año Académico: " }}</b> {{ item.AñoAcademico }} | <b>{{ "Espacio Curricular: "}}</b>{{ item.EspacioCurricular }} <br/><hr/>
            <b-list-group>
              <b-list-group-item v-for="horario in item.HorariosCargoDetalleCurricular" v-bind:key="horario.Id">
                {{ horario.DisplayHorario }}
              </b-list-group-item>
            </b-list-group>
          </b-list-group-item>
        </b-list-group>
      </b-row>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "TablaDetalleCargoPersonal",
  props: {
    objeto: Object
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/TablaDetalleCargoPersonal.vue